export default __webpack_public_path__ + "static/media/img_interaciones_medicamentosas.16681008.svg";